/**
 * Custom Offer Boxes — Wiring to Kaching Bundles
 *
 * Supports MULTIPLE [data-sr-offers] sections on the page (e.g. sidebar +
 * lower "Special Offer" clone). All sections stay in sync: clicking an offer
 * box or toggling the subscription in any section updates every other one
 * AND the underlying Kaching state. Prices are synced from Kaching to all
 * sections in one pass.
 */
(function () {
  var sections = Array.prototype.slice.call(document.querySelectorAll('[data-sr-offers]'));
  if (!sections.length) return;

  var primary = sections[0];
  var variantId = primary.getAttribute('data-base-variant-id');
  var cacheKey = 'sr-prices-sub-' + variantId;
  var selectionKey = 'sr-selected-' + variantId;

  function boxesOf(section) { return section.querySelectorAll('.sr-offer-box'); }
  function subToggleOf(section) { return section.querySelector('.sr-subscribe-input'); }

  // Bottles per bundle by box index. [Buy 1, Buy 2+1, Buy 3+2]
  var BOTTLE_COUNT = [1, 3, 5];

  // ── lp-ghk: derive the strikethrough COMPARE from Kaching's OWN price ──────
  // Kaching already renders the correct, currency-converted, .99-rounded, sub-
  // aware price for each offer. We NEVER recompute or touch the price — we only
  // read it and set compare = price x total/paid. Box index → [paid, total]:
  //   0 Buy 1 Get 1 Free (1/2), 1 Buy 2 Get 1 Free (2/3), 2 Buy 3 Get 2 Free (3/5)
  var IS_GHK = document.body.classList.contains('template-suffix-lp-ghk') || document.body.classList.contains('template-suffix-lp-tallow-bundle') || document.body.classList.contains('template-suffix-lp-glow');
  // lp-ghk offers: Buy 1 Get 1, Buy 2 Get 1, Buy 3 Get 2 → paid 1/2/3, total 2/3/5.
  var GHK_PAID = [1, 2, 3];
  var GHK_TOTAL = [2, 3, 5];
  // Single-unit compare-at price ($69.99) in presentment units — compare for every
  // offer = total bottles × this. Read from the variant's compare_at_price (cents),
  // so it stays currency-correct under Markets.
  var GHK_COMPARE_UNIT = parseFloat(primary.getAttribute('data-compare-unit') || '0') / 100;
  // Single-unit ONE-TIME price (presentment). Subscribe strikes through the
  // one-time bundle price (paid × this) so subscribing reads as a saving OFF the
  // one-time price — its reference is always ≤ the one-time card's, never higher.
  var GHK_ONETIME_UNIT = parseFloat(primary.getAttribute('data-onetime-unit') || '0') / 100;

  // Parse currency string ("CHF 47.00", "$39.97/ea") → numeric value
  function parseMoney(str) {
    if (!str) return NaN;
    var m = String(str).replace(/,/g, '').match(/[\d]+(?:\.[\d]+)?/);
    return m ? parseFloat(m[0]) : NaN;
  }
  // Reattach the currency prefix ("$", "CHF ", "€") from the source string
  function formatMoney(value, originalStr) {
    if (!isFinite(value)) return '';
    var m = String(originalStr || '').match(/^(\D*)/);
    var prefix = m ? m[1] : '$';
    return prefix + value.toFixed(2);
  }
  // Per-bottle price with "/ea" suffix
  function perEaPrice(totalStr, count) {
    var total = parseMoney(totalStr);
    if (!isFinite(total) || count <= 0) return totalStr || '';
    return formatMoney(total / count, totalStr) + '/ea';
  }
  // Per-bottle compare (single-bottle retail) — same value across all bundles
  function perEaCompare(totalStr, count) {
    var total = parseMoney(totalStr);
    if (!isFinite(total) || count <= 0) return totalStr || '';
    return formatMoney(total / count, totalStr);
  }

  // ── LP1 + EZ-LP: show a per-unit "$X.XX each" price under each offer title
  //    instead of the Kaching "You save X%" subtitle. each = offer total ÷
  //    bottles in that bundle (BOTTLE_COUNT[idx] = [1, 3, 5]). It reads the
  //    LIVE offer price, so it recomputes on every Kaching sync AND when the
  //    subscription toggle flips (sub vs one-time) — fully responsive.
  //    REVERT: set PER_UNIT_SUBTITLE = false → falls back to "You save %". ──
  var PER_UNIT_SUBTITLE = true;
  // lp-cook shows "SAVE $X" (compare − price) in the offer card; lp1/ez-lp show "$X each".
  var IS_LP_COOK = !!(document.body && document.body.classList.contains('template-suffix-lp-cook'));
  var IS_MSRLP = !!(document.body && document.body.classList.contains('template-suffix-msrlp'));
  var IS_PER_UNIT_TPL = IS_LP_COOK || !!(document.body && (
    document.body.classList.contains('template-suffix-lp1') ||
    document.body.classList.contains('template-suffix-ez-lp')
  ));
  // ── lp-cook offer cards: whole-number prices + overridden compare-at ────────
  // Offer 1 keeps Kaching's compare (≈102); offers 2 & 3 override compare to
  // price × a fixed multiplier (currency-stable): 1.35 ≈ 259 (offer 2), 1.94 ≈
  // 433 (offer 3). All offer-card price/compare/save shown WITHOUT decimals.
  var COOK_CMP_MULT = [0, 1.35, 1.94]; // 0 = keep Kaching's own compare
  function cookWhole(value, tplStr) {
    if (!isFinite(value)) return '';
    var m = String(tplStr || '').match(/^(\D*)/);
    var prefix = m ? m[1] : '$';
    return prefix + Math.round(value);
  }
  function cookPrice(str) {
    if (!IS_LP_COOK || !str) return str;
    var v = parseMoney(str);
    return isFinite(v) ? cookWhole(v, str) : str;
  }
  function cookCompare(priceStr, compareStr, idx) {
    if (!IS_LP_COOK) return compareStr;
    var mult = COOK_CMP_MULT[idx];
    if (mult && mult > 0) {
      var p = parseMoney(priceStr);
      if (isFinite(p)) return cookWhole(p * mult, compareStr || priceStr);
    }
    var c = parseMoney(compareStr);
    return isFinite(c) ? cookWhole(c, compareStr) : compareStr;
  }
  function offerSubtitleText(priceStr, compareStr, idx) {
    if (IS_LP_COOK) {
      // compareStr / priceStr are already the whole, overridden display values.
      var save = parseMoney(compareStr) - parseMoney(priceStr);
      if (isFinite(save) && save > 0.5) return 'SAVE ' + cookWhole(save, compareStr || priceStr);
      return '';
    }
    var count = BOTTLE_COUNT[idx] || 1;
    var total = parseMoney(priceStr);
    if (!isFinite(total)) return '';
    return formatMoney(total / count, priceStr) + (IS_MSRLP ? ' / bottle' : ' each');
  }
  // Sets the offer subtitle on `el`; returns true if it handled it so the
  // caller skips writing the default Kaching subtitle.
  function applyPerUnitSubtitle(el, priceStr, idx, compareStr) {
    if (!el || !PER_UNIT_SUBTITLE || !IS_PER_UNIT_TPL) return false;
    var txt = offerSubtitleText(priceStr, compareStr, idx);
    if (IS_LP_COOK) {
      // lp-cook always owns the subtitle — blank when there's no real saving
      // (Buy 1 one-time), so the Kaching "You save 50%" never falls through.
      if (el.textContent.trim() !== (txt || '')) el.textContent = (txt || '');
      return true;
    }
    if (!txt) return false;
    if (el.textContent.trim() !== txt) el.textContent = txt;
    return true;
  }
  // % OFF computed from per-ea values
  function computePercent(priceStr, compareStr) {
    var p = parseMoney(priceStr), c = parseMoney(compareStr);
    if (!isFinite(p) || !isFinite(c) || c <= 0 || p >= c) return '';
    return Math.round((1 - p / c) * 100) + '% OFF';
  }

  // Highest offer % (best/last tier = most saved) → write into the subscribe toggle's
  // "Subscribe & SAVE X%" so it auto-tracks real prices/discount on any product.
  function updateSubPercent() {
    // Only reflect the SUBSCRIBED saving (the "& SAVE X%" is about subscribing) —
    // don't let it change when the toggle is off, since the offer %s move with the toggle.
    var sub = document.querySelector('.sr-subscribe-input');
    if (sub && !sub.checked) return;
    var max = 0;
    document.querySelectorAll('[data-sr-percent]').forEach(function (el) {
      var m = (el.textContent || '').match(/(\d+)\s*%/);
      if (m) { var n = parseInt(m[1], 10); if (n > max) max = n; }
    });
    if (max > 0) document.querySelectorAll('[data-sr-sub-percent]').forEach(function (el) {
      if (el.textContent.trim() !== max + '%') el.textContent = max + '%';
    });
  }

  // ── lp-ghk: compute offer-box + price-row prices/compares from the model,
  // overriding Kaching's values so they're correct and move with the toggle. ──
  // Parse the numeric value out of a money string in any currency/format
  // ("CHF 39.90", "$39.99", "39,90 €", "1'234.50").
  function ghkParseNum(str) {
    if (!str) return NaN;
    var m = String(str).match(/\d[\d.,' \s]*\d|\d/);
    if (!m) return NaN;
    var t = m[0].replace(/[ '\s]/g, '');
    var lastDot = t.lastIndexOf('.'), lastComma = t.lastIndexOf(',');
    var dec = Math.max(lastDot, lastComma);
    if (dec > -1 && (t.length - dec) <= 3) {
      var intp = t.slice(0, dec).replace(/[.,]/g, '');
      return parseFloat(intp + '.' + t.slice(dec + 1));
    }
    return parseFloat(t.replace(/[.,]/g, ''));
  }
  // Format a numeric value using an existing money string as a template, so the
  // currency symbol/code, its position, and the decimal separator are preserved.
  function ghkFormatLike(value, tpl) {
    var m = String(tpl).match(/\d[\d.,' \s]*\d|\d/);
    if (!m) return value.toFixed(2);
    var token = m[0], dec = '.';
    var dm = token.match(/([.,])(\d{1,2})$/);
    if (dm) dec = dm[1];
    return tpl.replace(token, value.toFixed(2).replace('.', dec));
  }
  // Non-USD .99 rounding: if a price lands on a whole number (.00 — how non-USD
  // markets round after conversion), show it one cent under as .99 (CHF 70.00 →
  // 69.99). USD is already .99 (Kaching), so it never triggers. Idempotent.
  function ghk99(str) {
    var n = ghkParseNum(str);
    if (!isFinite(n) || n < 1) return str;
    var cents = Math.round(n * 100) % 100;
    // X.00 → (X-1).99 (non-USD markets that round to whole numbers)
    if (cents === 0) return ghkFormatLike(n - 0.01, str);
    // X.97/.98/.99 → X.99 (cleans the cents Kaching/Seal produce by multiplying
    // a per-bottle price, e.g. 49.99×2 = 99.98 → 99.99, 49.99×3×0.8 = 119.98 → 119.99)
    if (cents >= 97) return ghkFormatLike(Math.floor(n) + 0.99, str);
    return str; // any other ending left untouched
  }
  // Compare-at variant of ghk99: keep the EXACT cents so total × $59.99 shows its
  // true ending (2× = .98, 3× = .97, 5× = .95) instead of snapping up to .99. Still
  // fixes a non-USD .00 → .99 so a converted compare never shows a flat whole number.
  function ghk99c(str) {
    var n = ghkParseNum(str);
    if (!isFinite(n) || n < 1) return str;
    var cents = Math.round(n * 100) % 100;
    if (cents === 0) return ghkFormatLike(n - 0.01, str); // non-USD .00 → (X-1).99 only
    return str; // keep exact cents (no .97/.98 → .99 snap)
  }
  // For each offer, set the strikethrough compare = Kaching's own price x
  // total/paid. The PRICE itself is never read-for-base or recomputed, so it
  // can never inflate. Runs after every Kaching sync / toggle / offer click.
  function computeGhkPrices() {
    if (!IS_GHK) return;
    sections.forEach(function (section) {
      boxesOf(section).forEach(function (box, i) {
        if (GHK_PAID[i] == null || GHK_PAID[i] === 0) return;
        var priceEl = box.querySelector('[data-sr-price]');
        var cmpEl = box.querySelector('[data-sr-compare]');
        if (!priceEl || !cmpEl) return;
        var nowStr = priceEl.textContent;
        var nowNum = ghkParseNum(nowStr);
        if (!isFinite(nowNum)) return;
        // MSRP-anchored compare: total bottles × the single-unit compare-at ($59.99),
        // currency-correct via Markets. Fixed across plans (same strikethrough on
        // subscribe + one-time) so it reads cleanly against a Meta-ad price.
        var cmpVal = GHK_COMPARE_UNIT * GHK_TOTAL[i];
        cmpEl.textContent = ghk99c(ghkFormatLike(cmpVal, nowStr));
        priceEl.textContent = ghk99(nowStr); // non-USD .00 → .99 (USD untouched)
      });
    });
    // Price row mirrors the active offer: copy its (Kaching) price, derive compare.
    var want = ghkActivePriceNum();
    if (!want) return;
    var row = document.getElementById('price-row-anchor');
    if (row) {
      var pe = row.querySelector('[data-product-price]');
      var ce = row.querySelector('[data-compare-price]');
      var wrap = row.querySelector('[data-product-price-wrap]');
      if (pe) pe.textContent = ghk99(want.tpl);
      if (ce) ce.textContent = ghk99c(ghkFormatLike(want.cmp, want.tpl));
      if (wrap) wrap.classList.remove('hide');
    }
    ghkGuardPriceRow();
  }

  // The active offer's price (read from its box — Kaching's value) + derived
  // compare. tpl is the box's own money string, so currency/format are exact.
  function ghkActivePriceNum() {
    var active = primary.querySelector('.sr-offer-box--active');
    if (!active) return null;
    var idx = parseInt(active.dataset.index, 10);
    if (GHK_PAID[idx] == null || GHK_PAID[idx] === 0) return null;
    var priceEl = active.querySelector('[data-sr-price]');
    var tpl = priceEl ? priceEl.textContent : '';
    var nowNum = ghkParseNum(tpl);
    if (!isFinite(nowNum)) return null;
    var cmp = GHK_COMPARE_UNIT * GHK_TOTAL[idx];
    return { now: nowNum, cmp: cmp, tpl: tpl };
  }
  // Guard the price row: the theme rewrites [data-product-price] to the plain
  // single/selling-plan price when the plan flips, which flashed between our two
  // writes. This re-asserts the correct bundle price the instant anything else
  // changes it (MutationObserver = pre-paint microtask, so the blip never shows).
  // It tolerates stripCurrencyPrefix() (number unchanged) and only fixes a wrong
  // NUMBER, so the two observers settle instead of looping.
  var ghkRowGuardOn = false;
  function ghkGuardPriceRow() {
    if (!IS_GHK || ghkRowGuardOn || !window.MutationObserver) return;
    var row = document.getElementById('price-row-anchor');
    if (!row) return;
    ghkRowGuardOn = true;
    var applying = false;
    new MutationObserver(function () {
      if (applying) return;
      var want = ghkActivePriceNum();
      if (!want) return;
      var pe = row.querySelector('[data-product-price]');
      if (!pe) return;
      var ce = row.querySelector('[data-compare-price]');
      // Re-assert BOTH the now AND the compare. The theme reverts the compare to
      // the product's single-bottle compare_at_price on re-render; if we only
      // watched the now, that stale strikethrough would stick. Compare against
      // the exact rounded strings we write (tolerate stripCurrencyPrefix; no
      // half-cent loop because want.now is Kaching's clean .99 value).
      var wantNowStr = ghk99(want.tpl);
      var wantCmpStr = ghk99c(ghkFormatLike(want.cmp, want.tpl));
      var curNow = ghkParseNum(pe.textContent);
      var curCmp = ce ? ghkParseNum(ce.textContent) : null;
      var wantNowNum = ghkParseNum(wantNowStr);
      var wantCmpNum = ghkParseNum(wantCmpStr);
      var nowOk = isFinite(curNow) && Math.abs(curNow - wantNowNum) < 0.005;
      var cmpOk = !ce || (isFinite(curCmp) && isFinite(wantCmpNum) && Math.abs(curCmp - wantCmpNum) < 0.005);
      if (nowOk && cmpOk) return;
      applying = true;
      var wrap = row.querySelector('[data-product-price-wrap]');
      pe.textContent = wantNowStr;
      if (ce) ce.textContent = wantCmpStr;
      if (wrap) wrap.classList.remove('hide');
      applying = false;
    }).observe(row, { childList: true, subtree: true, characterData: true });
  }

  // --- Restore cached data immediately (before Kaching loads) ---
  try {
    var cached = JSON.parse(localStorage.getItem(cacheKey));
    if (cached && cached.length) {
      sections.forEach(function (section) {
        var boxes = boxesOf(section);
        cached.forEach(function (entry, i) {
          if (!boxes[i]) return;
          var p = boxes[i].querySelector('[data-sr-price]');
          var c = boxes[i].querySelector('[data-sr-compare]');
          var t = boxes[i].querySelector('[data-sr-title]');
          var s = boxes[i].querySelector('[data-sr-subtitle]');
          var pct = boxes[i].querySelector('[data-sr-percent]');
          var b = boxes[i].querySelector('[data-sr-badge]');
          var cPrice = cookPrice(entry.price);
          var cCompare = cookCompare(entry.price, entry.compare, i);
          if (p && entry.price) p.textContent = cPrice;
          if (c && entry.compare) c.textContent = cCompare;
          if (t && entry.title) t.textContent = entry.title;
          if (s && !applyPerUnitSubtitle(s, cPrice, i, cCompare) && entry.subtitle) s.textContent = entry.subtitle;
          if (pct) pct.textContent = computePercent(entry.price, entry.compare) || ' ';
          if (b && entry.badge) { b.textContent = entry.badge; b.style.display = ''; }
          if (b && !entry.badge) b.style.display = 'none';
        });
        section.classList.add('sr-prices-ready');
      });
    }
    updateSubPercent();
  } catch (e) {}

  // --- Restore selected offer box ---
  function setActiveIndexEverywhere(idx) {
    sections.forEach(function (section) {
      var boxes = boxesOf(section);
      boxes.forEach(function (b, i) {
        b.classList.toggle('sr-offer-box--active', i === idx);
        var radio = b.querySelector('.sr-offer-radio');
        if (radio) radio.checked = (i === idx);
      });
    });
  }

  // Default offer on every load: lp-cook = first offer (index 0), others = middle (index 1).
  // No localStorage restore — last-selected is intentionally NOT persisted.
  setActiveIndexEverywhere(IS_LP_COOK ? 0 : 1);

  // Render correct lp-ghk prices immediately on load (sub is checked by default).
  computeGhkPrices();

  // --- Click wiring on every section's boxes ---
  sections.forEach(function (section) {
    var boxes = boxesOf(section);
    boxes.forEach(function (box) {
      box.addEventListener('click', function () {
        var i = parseInt(box.dataset.index, 10);
        setActiveIndexEverywhere(i);
        clickKachingBar(i);
        computeGhkPrices();
        // Don't persist selection — middle offer always wins on next load.
      });
    });
  });

  // --- Subscription toggle (all sections mirror each other) ---
  function setSubscribeEverywhere(checked) {
    sections.forEach(function (section) {
      var t = subToggleOf(section);
      if (t && t.checked !== checked) t.checked = checked;
    });
  }

  // Sync the visible action-link text to current subscription state across all sections
  function refreshActionLinks(checked) {
    document.querySelectorAll('[data-sr-subscribe-action]').forEach(function (a) {
      var on = a.getAttribute('data-on-text');
      var off = a.getAttribute('data-off-text');
      if (!on || !off) return;
      a.textContent = checked ? on : off;
    });
  }

  sections.forEach(function (section) {
    var subToggle = subToggleOf(section);
    var toggleContainer = section.querySelector('[data-sr-subscribe-toggle]');
    if (!subToggle) return;

    subToggle.addEventListener('change', function () {
      setSubscribeEverywhere(this.checked);
      refreshActionLinks(this.checked);
      wireSubscription(this.checked);
      computeGhkPrices();
      var kb = document.querySelector('kaching-bundle');
      if (kb) {
        var subObs = new MutationObserver(function (m, observer) {
          syncPrices();
          observer.disconnect();
        });
        subObs.observe(kb, { childList: true, subtree: true, characterData: true });
      }
      setTimeout(syncPrices, 300);
    });

    if (toggleContainer) {
      var isLinkStyle = toggleContainer.classList.contains('sr-subscription-toggle--link');
      toggleContainer.addEventListener('click', function (e) {
        if (e.target === subToggle) return;
        // Link style: only toggle when the action link is clicked.
        // Checkbox style: any click on the container toggles.
        if (isLinkStyle && !e.target.closest('[data-sr-subscribe-action]')) return;
        e.preventDefault();
        subToggle.checked = !subToggle.checked;
        subToggle.dispatchEvent(new Event('change'));
      });
    }
  });

  // --- Kaching interaction ---

  function getBundleBars() {
    var kb = document.querySelector('kaching-bundle');
    if (!kb) return [];
    var allBars = kb.querySelectorAll('.kaching-bundles__bar');
    var subsBars = kb.querySelectorAll('.kaching-bundles__subscriptions .kaching-bundles__bar');
    var subsSet = new Set();
    subsBars.forEach(function (b) { subsSet.add(b); });
    var bundleBars = [];
    allBars.forEach(function (b) {
      if (!subsSet.has(b)) bundleBars.push(b);
    });
    return bundleBars;
  }

  function clickKachingBar(index) {
    var bars = getBundleBars();
    if (!bars[index]) return;
    var radio = bars[index].querySelector('input[type="radio"]');
    if (radio) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
      radio.dispatchEvent(new Event('input', { bubbles: true }));
    }
    bars[index].click();
  }

  function wireSubscription(subscribe) {
    var kb = document.querySelector('kaching-bundle');
    if (!kb) return;
    var subs = kb.querySelector('.kaching-bundles__subscriptions');
    if (!subs) return;
    var subscribeBar = subs.querySelector('.kaching-bundles__bar:nth-child(1)');
    var oneTimeBar = subs.querySelector('.kaching-bundles__bar:nth-child(2)');

    if (subscribe && subscribeBar) {
      subscribeBar.classList.add('kaching-bundles__bar--selected');
      if (oneTimeBar) oneTimeBar.classList.remove('kaching-bundles__bar--selected');
      subscribeBar.click();
    } else if (!subscribe && oneTimeBar) {
      if (subscribeBar) subscribeBar.classList.remove('kaching-bundles__bar--selected');
      oneTimeBar.classList.add('kaching-bundles__bar--selected');
      oneTimeBar.click();
    }
  }

  // --- Price sync + cache ---

  function syncPrices() {
    var bars = getBundleBars();
    var toCache = [];
    bars.forEach(function (bar, i) {
      var priceEl = bar.querySelector('.kaching-bundles__bar-price');
      var compareEl = bar.querySelector('.kaching-bundles__bar-full-price');
      var titleEl = bar.querySelector('.kaching-bundles__bar-title');
      var subtitleEl = bar.querySelector('.kaching-bundles__bar-subtitle');
      var badgeEl = bar.querySelector('.kaching-bundles__bar-most-popular__content');

      var newPrice = priceEl ? priceEl.textContent.trim() : '';
      var newCompare = compareEl ? compareEl.textContent.trim() : '';
      var newTitle = titleEl ? titleEl.textContent.trim() : '';
      var newSubtitle = subtitleEl ? subtitleEl.textContent.trim() : '';
      var newBadge = badgeEl ? badgeEl.textContent.trim() : '';

      var dispPrice = cookPrice(newPrice);
      var dispCompare = cookCompare(newPrice, newCompare, i);
      var newPercent = computePercent(dispPrice, dispCompare) || '';
      sections.forEach(function (section) {
        var boxes = boxesOf(section);
        if (!boxes[i]) return;
        var ourPrice = boxes[i].querySelector('[data-sr-price]');
        var ourCompare = boxes[i].querySelector('[data-sr-compare]');
        var ourTitle = boxes[i].querySelector('[data-sr-title]');
        var ourSubtitle = boxes[i].querySelector('[data-sr-subtitle]');
        var ourPercent = boxes[i].querySelector('[data-sr-percent]');
        var ourBadge = boxes[i].querySelector('[data-sr-badge]');
        if (ourPrice && dispPrice && ourPrice.textContent.trim() !== dispPrice) ourPrice.textContent = dispPrice;
        if (ourCompare) { if (dispCompare) { if (ourCompare.textContent.trim() !== dispCompare) ourCompare.textContent = dispCompare; } else if (IS_MSRLP) ourCompare.textContent = ''; }
        if (ourTitle && newTitle && ourTitle.textContent.trim() !== newTitle) ourTitle.textContent = newTitle;
        if (ourSubtitle && !applyPerUnitSubtitle(ourSubtitle, dispPrice, i, dispCompare) && newSubtitle && ourSubtitle.textContent.trim() !== newSubtitle) ourSubtitle.textContent = newSubtitle;
        if (ourPercent && ourPercent.textContent.trim() !== newPercent) ourPercent.textContent = newPercent;
        if (ourBadge && newBadge) { ourBadge.textContent = newBadge; ourBadge.style.display = ''; }
        if (ourBadge && !newBadge) ourBadge.style.display = 'none';
      });

      toCache.push({ price: newPrice, compare: newCompare, title: newTitle, subtitle: newSubtitle, badge: newBadge });
    });
    computeGhkPrices();
    updateSubPercent();
    try { localStorage.setItem(cacheKey, JSON.stringify(toCache)); } catch (e) {}
  }

  // --- Init ---

  function onReady() {
    var activeBox = primary.querySelector('.sr-offer-box--active');
    if (activeBox) {
      clickKachingBar(parseInt(activeBox.dataset.index, 10));
    }

    sections.forEach(function (section) {
      var t = subToggleOf(section);
      if (t) t.checked = true;
    });
    wireSubscription(true);

    syncPrices();
    sections.forEach(function (s) { s.classList.add('sr-prices-ready'); });
  }

  function waitForKaching() {
    var check = function () {
      var kb = document.querySelector('kaching-bundle');
      if (kb && kb.querySelectorAll('.kaching-bundles__bar').length >= 3) {
        onReady();
        return true;
      }
      return false;
    };

    if (check()) return;

    var obs = new MutationObserver(function (m, observer) {
      if (check()) observer.disconnect();
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  // --- Attach the SELECTED offer's title to the product form as a line
  // property (_sr_offer) so it shows in the cart drawer. Many of our offers are
  // virtual/Kaching-driven and don't create a Shopify discount allocation, so
  // the cart has no offer data otherwise. Read the active box's title at click
  // time (titles are synced by then) in the capture phase, so it's on the form
  // before the submit handler serializes it. ---
  document.addEventListener('click', function (e) {
    var atc = e.target.closest('[data-add-to-cart], .add-to-cart, button[name="add"]');
    if (!atc) return;
    var form = atc.closest('form[action*="/cart/add"]');
    if (!form) return;
    var activeBox = document.querySelector('[data-sr-offers] .sr-offer-box--active');
    var titleEl = activeBox && activeBox.querySelector('[data-sr-title]');
    var title = titleEl ? titleEl.textContent.trim() : '';
    // Fallback: if Kaching hasn't synced the offer title yet, derive it from the
    // active offer index so _sr_offer is ALWAYS set on the GHK add. Without it the
    // cart line gets no `cart__item--lpg-bundle` class until Kaching's discount
    // lands a few seconds later — which left the tier stepper dead until that
    // re-render (the image flicker). lp-ghk only.
    if (!title && IS_GHK && activeBox) {
      var _ai = parseInt(activeBox.dataset.index, 10);
      if (GHK_PAID[_ai] != null) title = 'Buy ' + GHK_PAID[_ai] + ' Get ' + (GHK_TOTAL[_ai] - GHK_PAID[_ai]) + ' Free';
    }
    if (!title) return;
    var input = form.querySelector('input[name="properties[_sr_offer]"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[_sr_offer]';
      form.appendChild(input);
    }
    input.value = title;
  }, true);

  // Cart-drawer trash/remove: ajax-remove the ENTIRE line in place, never
  // navigate to /cart. The lp-ghk page is a closed funnel (product URL +
  // checkout only). The theme's qty path bails on quantity:0 (`if (!qty)
  // return`), so we POST quantity:0 straight to the cart API, then fire the
  // theme's own `cart:build` event to re-render the drawer.
  document.addEventListener('click', function (e) {
    var rm = e.target.closest('.cart__remove a, .cart__remove-icon, a.cart__remove');
    if (!rm) return;
    e.preventDefault();
    e.stopPropagation();
    var item = rm.closest('.cart__item');
    var key = item && item.getAttribute('data-key');
    if (!key) return;
    var isBundle = item.classList.contains('cart__item--lpg-bundle');
    // Close the cart ONLY if this is the last real product (excludes $0 free lines
    // + the hidden protection add-on). Otherwise remove this line in place and keep
    // the drawer open. The clicked item is still in the DOM here, so length 1 = last.
    var products = document.querySelectorAll('#CartDrawer .cart__item:not(.cart__item--free):not(.cart__item--sp-hidden)');
    var lastProductPre = products.length <= 1;
    // FBT / upsell removal (non-bundle, not the last product): pure backend.
    // No /cart.js reconcile, no cart:build re-render — those wholesale-replace
    // [data-products] and were briefly re-rendering the removed line before the
    // fresh markup landed (the "disappear → reappear → disappear" flicker the
    // user reported). The bundle line is unchanged on an FBT remove (Kaching
    // doesn't have free bottles tied to it, SP cleanup only matters when the
    // bundle goes), so a full rebuild buys nothing. Just optimistic DOM remove
    // + POST /cart/change.js + cart:updated for the footer recompute.
    if (!isBundle && !lastProductPre) {
      if (item.parentNode) item.parentNode.removeChild(item);
      document.dispatchEvent(new CustomEvent('cart:updated'));
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ id: key, quantity: 0 })
      }).catch(function (err) { try { console.error('[lpg-cart] fbtRemove:', err); } catch (e) {} });
      return;
    }
    // Bundle remove (or last product): full Kaching cleanup + state switch path.
    // If this is the LAST real product, the cart ends empty after removal — but
    // DON'T close the drawer yet. Closing BEFORE the async removal landed left the
    // drawer shut while the cart was still in flight, which froze the LP until it
    // finished. Keep the drawer open with the theme's default loading dim, and
    // close only AFTER the item is fully gone (in `rebuild`). Otherwise remove the
    // line in place and keep the drawer open.
    var lastProduct = products.length <= 1;
    if (lastProduct) {
      var loadEl = document.querySelector('#CartDrawer .drawer__inner');
      if (loadEl) loadEl.classList.add('is-loading');
    } else {
      if (item && item.parentNode) item.parentNode.removeChild(item); // instant remove, keep open
      document.dispatchEvent(new CustomEvent('cart:updated'));         // recompute footer
    }
    var rebuild = function () {
      var li = document.querySelector('#CartDrawer .drawer__inner');
      if (li) li.classList.remove('is-loading');
      document.dispatchEvent(new CustomEvent('cart:build'));
      // Close ONLY when the BUNDLE was removed as the last product. Last-FBT
      // removal keeps the drawer open in empty state so the FBT cards stay
      // visible for re-adding — closing there would hide the upsell experience
      // entirely the moment a customer empties their FBT lines.
      if (lastProduct && isBundle) document.dispatchEvent(new CustomEvent('cart:close'));
    };
    // A Kaching "Buy N Get M Free" bundle is several line items: the paid line +
    // a separate $0 "free" line (which we hide in the drawer). Removing just the
    // clicked line orphans the free one. So we remove the clicked line PLUS only
    // ITS own free bottles — (total - paid) $0 units of the same product — so a
    // second bundle of the same product (added separately) and any other product
    // (e.g. a future AOV upsell) both stay in the cart untouched.
    fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = (cart && cart.items) || [];
        var clicked = items.filter(function (it) { return it.key === key; })[0];
        var updates = {};
        updates[key] = 0; // always remove the clicked (paid) line
        if (clicked) {
          // Free bottles that belong to THIS bundle = (total - paid) from its
          // offer title. Remove only that many $0 units of the same product, so
          // other bundles of the same product (added separately) stay intact.
          var off = clicked.properties && clicked.properties._sr_offer;
          var parts = off ? String(off).toLowerCase().split(' ') : [];
          var paid = parseInt(parts[1], 10) || 0;
          var freeNeeded = (parseInt(parts[3], 10) || 0); // M free bottles per bundle
          if (freeNeeded > 0) {
            items.forEach(function (it) {
              if (freeNeeded <= 0 || it.key === key) return;
              var isFree = (it.final_price === 0 || it.price === 0);
              if (it.product_id === clicked.product_id && isFree) {
                updates[it.key] = 0;
                freeNeeded -= it.quantity;
              }
            });
          }
        }
        // Shipping Protection is an add-on, not a product: if removing this line
        // leaves nothing but protection (+ $0 free lines), drop protection too in
        // the SAME update so the cart ends TRULY empty — no itemless limbo state.
        var spTog = document.querySelector('[data-ghk-protect-toggle]');
        var spVar = spTog && spTog.getAttribute('data-ghk-protect-variant');
        var realRemains = items.some(function (it) {
          if (updates[it.key] === 0) return false;                                  // being removed
          if (spVar && String(it.variant_id) === String(spVar)) return false;       // protection add-on
          return it.final_price !== 0 && it.price !== 0;                            // skip $0 free lines
        });
        if (!realRemains && spVar) {
          items.forEach(function (it) { if (String(it.variant_id) === String(spVar)) updates[it.key] = 0; });
        }
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ updates: updates })
        });
      })
      .then(rebuild)
      .catch(rebuild);
  });

  // ── Cart-drawer offer stepper — INSTANT, commit-at-checkout ──────────────────
  // +/- on a bundle line switches the OFFER TIER exactly like clicking an offer
  // box: it repaints the drawer DISPLAY instantly (title / price / qty / each +
  // the free-shipping bar) and mirrors the offer selection, writing NOTHING to the
  // cart — so the drawer never closes and there's zero lag. The real Kaching commit
  // happens once, on Checkout (skip-cart style), and ONLY if the displayed offer
  // differs from what's actually in the cart; if they match, native checkout runs
  // untouched (so it can never break checkout). Every handler is wrapped so any
  // failure logs '[lpg-cart] ...' to the console instead of breaking silently.
  // lp-ghk ONLY — gated so other landing pages keep the theme's default stepper.
  if (IS_GHK) {
  function lpgTierIndex(paid) { return paid >= 3 ? 2 : (paid === 2 ? 1 : 0); }
  function lpgLog(where, err) { try { console.error('[lpg-cart] ' + where + ':', err); } catch (e) {} }
  function lpgTriggerATC() {
    var atc = document.querySelector('form[action*="/cart/add"] button[name="add"], form[action*="/cart/add"] [data-add-to-cart], .add-to-cart');
    if (atc) atc.click();
  }

  var lpgSel = null;       // offer index DISPLAYED in the drawer
  var lpgActualIdx = null; // offer index actually IN the cart (decides checkout intercept)

  function lpgInitSel() {
    try {
      var item = document.querySelector('#CartDrawer .cart__item--lpg-bundle:not(.cart__item--free)');
      if (!item) { lpgSel = null; lpgActualIdx = null; return; }
      var t = item.querySelector('.cart__item--bundle');
      var m = t ? t.textContent.toLowerCase().match(/buy\s+(\d+)/) : null;
      lpgSel = lpgActualIdx = lpgTierIndex(m ? parseInt(m[1], 10) : 1);
    } catch (e) { lpgLog('initSel', e); }
  }
  // Server-rendered cart prices come through as .00 in non-USD markets; rewrite to
  // .99. Change-guarded (only writes when the value actually changes) so the
  // MutationObserver below can't loop on our own writes.
  function lpgApply99ToCart() {
    try {
      document.querySelectorAll('#CartDrawer .cart__item--lpg-bundle:not(.cart__item--free)').forEach(function (item) {
        ['.lpg-cart-now', '.lpg-cart-compare', '.cart__price'].forEach(function (sel) {
          var el = item.querySelector(sel);
          if (!el) return;
          // Compare keeps exact cents (.97/.98); now + price snap to .99.
          var fn = sel === '.lpg-cart-compare' ? ghk99c : ghk99;
          var v = fn(el.textContent); if (v !== el.textContent) el.textContent = v;
        });
        var ea = item.querySelector('.lpg-cart-each');
        if (ea) { var b = ea.textContent.replace(/\s*each$/i, ''); var v = ghk99(b) + ' each'; if (v !== ea.textContent) ea.textContent = v; }
      });
    } catch (e) { lpgLog('apply99cart', e); }
  }
  function lpgOnRender() { lpgInitSel(); lpgApply99ToCart(); }
  document.addEventListener('cart:build', function () { setTimeout(lpgOnRender, 60); });
  document.addEventListener('drawerOpen.CartDrawer', function () { setTimeout(lpgOnRender, 60); });
  // Catch EVERY drawer re-render (incl. the first add, where the line appears after
  // the timers above) — re-apply .99 the instant the cart drawer's DOM changes.
  (function () {
    var cd = document.querySelector('#CartDrawer');
    if (cd && window.MutationObserver) {
      new MutationObserver(function () { lpgApply99ToCart(); }).observe(cd, { childList: true, subtree: true, characterData: true });
    }
  })();

  // Repaint the drawer (line + free-ship bar) for offer index `idx`, using the
  // offer's own Kaching price (currency-correct, sub-aware) from its box.
  function lpgPaint(idx) {
    try {
      var paid = GHK_PAID[idx], total = GHK_TOTAL[idx], free = total - paid;
      var title = 'Buy ' + paid + ' Get ' + free + ' Free';
      var bundles = document.querySelectorAll('#CartDrawer .cart__item--lpg-bundle:not(.cart__item--free)');
      // STRUCTURAL switch first — always succeeds, so a tier change can never
      // silently do nothing even if the offer price isn't readable yet.
      bundles.forEach(function (item) {
        var el;
        if ((el = item.querySelector('.cart__item--bundle'))) el.textContent = title;
        if ((el = item.querySelector('.js-qty__num'))) el.value = paid;
      });
      // PRICES from the offer box (skip gracefully if not yet populated).
      var box = boxesOf(primary)[idx];
      var priceEl = box && box.querySelector('[data-sr-price]');
      var priceStr = priceEl ? priceEl.textContent.trim() : '';
      var num = ghkParseNum(priceStr);
      if (!isFinite(num)) { lpgLog('paint', 'price not ready for index ' + idx + ' (title/qty switched)'); return; }
      var cmpVal = GHK_COMPARE_UNIT * total;
      var eachVal = num / total;
      var nowStr = ghk99(priceStr);
      var compareStr = ghk99c(ghkFormatLike(cmpVal, priceStr));
      // Per-bottle "each" = what you pay ÷ bottles received (num ÷ total). Tier-
      // DEPENDENT under Buy-N-Get-M (Buy2Get1 ≈ price×2/3, Buy3Get2 ≈ price×3/5), so
      // it MUST be recomputed on every step — the server value is only right for the
      // rendered tier. Mirrors cart-item.liquid (lpg_now ÷ lpg_total); .99-cleaned.
      var eachStr = ghk99(ghkFormatLike(eachVal, priceStr)) + ' each';
      bundles.forEach(function (item) {
        var el;
        if ((el = item.querySelector('.lpg-cart-now'))) el.textContent = nowStr;
        if ((el = item.querySelector('.lpg-cart-compare'))) el.textContent = compareStr;
        if ((el = item.querySelector('.lpg-cart-each'))) el.textContent = eachStr;
        if ((el = item.querySelector('.cart__price'))) el.textContent = nowStr;
      });
      // The free-shipping bar is driven by ghkFootRender from the DISPLAYED cart
      // subtotal (products + protection), NOT from this single offer's price — the
      // MutationObserver fires it right after this repaint. Computing it here from
      // `num` (the offer price) ignored protection + other lines and made the bar
      // jump around / move backwards on a step. Just trigger the footer recompute.
      ghkFootRender();
    } catch (e) { lpgLog('paint', e); }
  }

  // Current displayed tier — read LIVE from the cart line's title each click, so
  // stepping never relies on a stale tracked value.
  function lpgCurrentIndex() {
    var item = document.querySelector('#CartDrawer .cart__item--lpg-bundle:not(.cart__item--free)');
    if (!item) return null;
    var t = item.querySelector('.cart__item--bundle');
    var m = t ? t.textContent.toLowerCase().match(/buy\s+(\d+)/) : null;
    if (!m) return null;
    return lpgTierIndex(parseInt(m[1], 10));
  }

  // +/- = switch tier, DISPLAY ONLY (no cart write, instant, can't fail silently).
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('#CartDrawer .cart__item--lpg-bundle .js-qty__adjust');
    if (!btn) return;
    e.preventDefault();
    e.stopImmediatePropagation(); // block the theme's raw quantity change
    try {
      var cur = lpgCurrentIndex();
      if (cur == null) cur = (lpgSel == null ? 0 : lpgSel);
      var dir = btn.classList.contains('js-qty__adjust--plus') ? 1 : -1;
      var target = Math.max(0, Math.min(2, cur + dir));
      if (target === cur) return; // already at the top / bottom tier
      lpgSel = target;
      // DISPLAY ONLY — no Kaching, no cart write (that's what slammed the drawer
      // shut and lagged). The real commit happens once, at checkout.
      lpgPaint(target);
    } catch (err) { lpgLog('step', err); }
  }, true);

  // ── FBT / non-bundle stepper — INSTANT optimistic +/- ────────────────────
  // The theme's QtySelector dispatches cart:quantity → CartForm.quantityChanged
  // → /cart/change.js → buildCart() (wholesale [data-products] re-render). That
  // adds both a network roundtrip's latency to the click AND a visible flicker.
  // We intercept in capture phase (matching the bundle stepper's strategy) to
  // block it, do the UI update synchronously, fire cart:updated for the footer,
  // and POST /cart/change.js in the background. Selector explicitly excludes the
  // bundle line — the bundle stepper above keeps full ownership of its handler
  // (Kaching-driven offer-tier display, do not touch).
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('#CartDrawer .cart__item:not(.cart__item--lpg-bundle):not(.cart__item--free):not(.cart__item--sp-hidden) .js-qty__adjust');
    if (!btn) return;
    e.preventDefault();
    e.stopImmediatePropagation();   // block the theme's QtySelector listener
    try {
      var item = btn.closest('.cart__item');
      if (!item) return;
      var input = item.querySelector('.js-qty__num');
      if (!input) return;
      var key = input.getAttribute('data-id') || item.getAttribute('data-key');
      if (!key) return;
      var dir = btn.classList.contains('js-qty__adjust--plus') ? 1 : -1;
      var curQty = parseInt(input.value, 10) || 1;
      var newQty = Math.max(0, curQty + dir);
      if (newQty === curQty) return;     // already at floor
      // Optimistic display update — qty input AND remove the line if it hit 0.
      input.value = newQty;
      if (newQty === 0 && item.parentNode) item.parentNode.removeChild(item);
      // Sync paint: line price (per-unit × qty) AND footer total + count +
      // free-ship bar all in the same frame as the qty change — no 30ms gap.
      ghkFootRender();
      document.dispatchEvent(new CustomEvent('cart:updated'));
      // Background commit — /cart/change.js with the new qty (0 = remove).
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ id: key, quantity: newQty })
      }).catch(function (err) { lpgLog('fbtStep', err); });
    } catch (err) { lpgLog('fbtStep', err); }
  }, true);

  function lpgBundleRemovalUpdates(cart) {
    var updates = {};
    ((cart && cart.items) || []).forEach(function (it) {
      if ((it.properties && it.properties._sr_offer) || it.final_price === 0 || it.price === 0) updates[it.key] = 0;
    });
    return updates;
  }

  // Checkout: only intercept when the displayed offer differs from the cart.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('#CartDrawer button[name="checkout"], #CartDrawer .cart__checkout');
    if (!btn) return;
    if (lpgSel == null || lpgActualIdx == null || lpgSel === lpgActualIdx) return; // no switch → native checkout
    e.preventDefault();
    e.stopImmediatePropagation();
    var go = function (url) { window.location.href = url || '/checkout'; };
    try {
      btn.setAttribute('disabled', 'disabled');
      fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var bundle = ((cart && cart.items) || []).filter(function (it) { return it.properties && it.properties._sr_offer; })[0];
          var wasSub = bundle ? !!bundle.selling_plan_allocation : true;
          return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ updates: lpgBundleRemovalUpdates(cart) }) })
            .then(function () {
              setActiveIndexEverywhere(lpgSel);
              clickKachingBar(lpgSel);
              wireSubscription(wasSub);
              document.addEventListener('ajaxProduct:added', function h() { document.removeEventListener('ajaxProduct:added', h); setTimeout(function () { go('/checkout'); }, 80); });
              setTimeout(lpgTriggerATC, 200);
              setTimeout(function () { go('/cart'); }, 6000); // safety fallback
            });
        })
        .catch(function (err) { lpgLog('checkout', err); go('/cart'); });
    } catch (err) { lpgLog('checkout', err); go('/cart'); }
  }, true);

  // ── lp-ghk cart-drawer footer ────────────────────────────────────────────
  // Count badge, You-saved, grand Total, and the Shipping-Protection toggle
  // (default ON). Totals are computed from the RENDERED line prices
  // (.lpg-cart-now / .lpg-cart-compare) — which the instant-stepper keeps in
  // sync — so the footer always matches what's on screen, even before a tier
  // switch is committed to Kaching. Shipping is NOT shown or added to the total
  // in the drawer; only the free-shipping PROGRESS BAR uses FREE_SHIP_THRESHOLD.
  var SP_OPTOUT_KEY = 'ghk_sp_optout';
  var spBusy = false;
  // The protection toggle (driven by the session opt-out flag) is the SINGLE
  // source of truth for the displayed total — instant, and never reset by a
  // background re-render. The real cart is reconciled to it on a DEBOUNCE, so
  // rapid on/off can't lag behind a storm of add/remove requests + rebuilds.
  var spSyncTimer = null;

  function ghkMoneyTpl() {
    var el = document.querySelector('#CartDrawer .lpg-cart-now')
          || document.querySelector('#CartDrawer .ghk-protect__price')
          || document.querySelector('#CartDrawer [data-subtotal]');
    var t = el ? el.textContent.trim() : '';
    return t || '$0.00';
  }

  // Guarded write — only touch the DOM when the value actually changes, so our
  // own footer updates can't re-trigger the #CartDrawer MutationObserver below
  // (which calls ghkFootRender). No-op writes = no mutation = no loop.
  function ghkTxt(el, val) { if (el && el.textContent !== val) el.textContent = val; }

  function ghkFootRender() {
    var foot = document.querySelector('[data-ghk-foot]');
    if (!foot) return;
    var items = document.querySelectorAll('#CartDrawer .cart__item');
    var tpl = null, prodSub = 0, compareSum = 0, bottles = 0, domHasSP = false;
    items.forEach(function (item) {
      if (item.classList.contains('cart__item--sp-hidden')) { domHasSP = true; return; }
      if (item.classList.contains('cart__item--free')) return; // $0 minted lines
      // Bundle lines use .lpg-cart-now (custom price markup); regular product
      // lines (FBT add-ons) use the theme's .cart__price. Fall back so FBT
      // items are counted in the cart total — otherwise they'd silently miss.
      var nowEl = item.querySelector('.lpg-cart-now') || item.querySelector('.cart__price');
      var now = nowEl ? ghkParseNum(nowEl.textContent) : NaN;
      if (!isFinite(now)) return;
      if (tpl === null && nowEl) tpl = nowEl.textContent.trim();
      var cmpEl = item.querySelector('.lpg-cart-compare');
      var cmp = cmpEl ? ghkParseNum(cmpEl.textContent) : NaN;
      if (item.classList.contains('cart__item--lpg-bundle')) {
        // Bundle: .lpg-cart-now is already the line total (lpg_now = final_line_price).
        prodSub += now;
        compareSum += (isFinite(cmp) && cmp > now) ? cmp : now;
        // Count = items they're BUYING (the paid "Buy N"), not paid+free. You buy
        // 5 and get 5 free → the cart shows 5, not 10. Matches cart.item_count.
        var titleEl = item.querySelector('.cart__item--bundle');
        var m = titleEl ? titleEl.textContent.match(/Buy\s+(\d+)\s+Get\s+(\d+)/i) : null;
        bottles += m ? parseInt(m[1], 10) : 1;
      } else {
        // Regular FBT/upsell line. cart-item.liquid renders .lpg-cart-now as
        // product.final_line_price (LINE TOTAL = per-unit × qty) and
        // .lpg-cart-compare as variant.compare_at_price × qty when compare >
        // price. On first encounter we derive per-unit by dividing the rendered
        // line total by qty, stash on the qty input, then on every subsequent
        // pass (e.g. after a stepper +/-) we recompute line total = per-unit ×
        // current qty and rewrite both .lpg-cart-now and .lpg-cart-compare.
        // After a theme cart:build re-render the input is replaced (dataset
        // wiped), so the next pass re-derives cleanly.
        var qEl = item.querySelector('.js-qty__num');
        var lineQty = qEl ? (parseInt(qEl.value, 10) || 1) : 1;
        var nowSpan = item.querySelector('.lpg-cart-now');
        var compareSpan = item.querySelector('.lpg-cart-compare');
        // First-touch stash: per-unit = displayed-line-total / qty.
        if (qEl && !qEl.dataset.unitPrice && nowSpan) {
          var lt = ghkParseNum(nowSpan.textContent);
          if (isFinite(lt)) qEl.dataset.unitPrice = lt / Math.max(lineQty, 1);
        }
        if (qEl && !qEl.dataset.unitCompare && compareSpan) {
          var ct = ghkParseNum(compareSpan.textContent);
          if (isFinite(ct)) qEl.dataset.unitCompare = ct / Math.max(lineQty, 1);
        }
        var perUnit = qEl && qEl.dataset.unitPrice ? parseFloat(qEl.dataset.unitPrice) : NaN;
        var perUnitCmp = qEl && qEl.dataset.unitCompare ? parseFloat(qEl.dataset.unitCompare) : NaN;
        var lineTotal = isFinite(perUnit) ? perUnit * lineQty : now;
        var compareLineTotal = isFinite(perUnitCmp) ? perUnitCmp * lineQty : 0;
        // Sync displays to current qty.
        if (nowSpan && isFinite(perUnit)) {
          var wantNow = ghkFormatLike(lineTotal, nowSpan.textContent);
          if (nowSpan.textContent.trim() !== wantNow) nowSpan.textContent = wantNow;
        }
        if (compareSpan && isFinite(perUnitCmp) && compareLineTotal > lineTotal) {
          var wantCmp = ghkFormatLike(compareLineTotal, compareSpan.textContent);
          if (compareSpan.textContent.trim() !== wantCmp) compareSpan.textContent = wantCmp;
        }
        prodSub += lineTotal;
        compareSum += (compareLineTotal > lineTotal) ? compareLineTotal : lineTotal;
        bottles += lineQty;
      }
    });
    if (tpl === null) tpl = ghkMoneyTpl();

    // The toggle (driven by the opt-out flag) is the instant source of truth for
    // the total. Keep it visually in sync with that intent on every render so a
    // background re-render can never snap it back to a lagging cart state.
    var tog = document.querySelector('[data-ghk-protect-toggle]');
    var wantSP = (sessionStorage.getItem(SP_OPTOUT_KEY) !== '1');
    if (tog) { if (tog.checked !== wantSP) tog.checked = wantSP; } else { wantSP = false; }
    // Shipping Protection is an ADD-ON, never a product on its own. It only counts
    // toward the total when there's a real product in the cart (bottles > 0) — so
    // a protection-only cart reads as empty, not as a $9.99 order.
    var hasSP = wantSP && bottles > 0;
    var spPriceEl = document.querySelector('.ghk-protect__price');
    var spPrice = (hasSP && spPriceEl) ? (ghkParseNum(spPriceEl.textContent) || 0) : 0;

    // Count badge = total bottles in cart (incl. the free ones the offer adds)
    var ghkCountEl = document.querySelector('[data-ghk-cart-count]');
    if (ghkCountEl) {
      ghkTxt(ghkCountEl, String(bottles));
      // Hide the badge entirely when the cart is empty — a "0" badge in the
      // header reads as "cart has 0 items" instead of just being absent.
      ghkCountEl.style.display = bottles > 0 ? '' : 'none';
    }

    // You saved (green) — hidden when there's nothing to show
    var saved = compareSum - prodSub;
    var savedWrap = document.querySelector('[data-ghk-saved]');
    var savedAmt = document.querySelector('[data-ghk-saved-amt]');
    if (savedWrap && savedAmt) {
      if (saved > 0.005) {
        savedWrap.style.display = '';
        ghkTxt(savedAmt, '-' + ghkFormatLike(saved, tpl));
      } else {
        savedWrap.style.display = 'none';
      }
    }

    // Free-shipping threshold basis = the DISPLAYED cart subtotal (products +
    // protection), the same number cart.total_price holds — so the progress bar
    // tracks the displayed offer tier. Shipping itself is NOT shown or added to
    // the total in the drawer; only the bar below consumes the threshold.
    var threshold = (window.FREE_SHIP_THRESHOLD || 8800) / 100;
    var cartSubtotal = prodSub + spPrice;

    // Total = products + protection (shipping excluded from the drawer)
    var grand = cartSubtotal;
    ghkTxt(document.querySelector('[data-ghk-total]'), ghkFormatLike(grand, tpl));

    // ── Free-shipping progress bar — driven from the SAME displayed cartSubtotal
    // (not the offer price), so it can't move backwards on a tier step or disagree
    // with the total. Guarded writes so it can't loop the MutationObserver. ──
    var fsRemain = threshold - cartSubtotal;
    var fsBar = document.querySelector('[data-free-shipping-bar]');
    if (fsBar) fsBar.classList.toggle('free-shipping-bar--complete', fsRemain <= 0);
    var fsFill = document.querySelector('[data-free-shipping-fill]');
    if (fsFill) {
      var pct = (threshold > 0 ? Math.min(cartSubtotal / threshold * 100, 100) : 0) + '%';
      if (fsFill.style.width !== pct) { fsFill.style.transition = 'width .4s ease'; fsFill.style.width = pct; }
    }
    var fsMsg = document.querySelector('[data-free-shipping-message]');
    if (fsMsg) {
      var fsHtml = fsRemain <= 0
        ? "Congrats! You unlock <strong>free shipping</strong>"
        : "You're " + ghk99(ghkFormatLike(fsRemain, tpl)) + ' away from <strong>Free Shipping</strong>';
      if (fsMsg.innerHTML !== fsHtml) fsMsg.innerHTML = fsHtml;
    }
  }

  function ghkHasBundle() {
    return !!document.querySelector('#CartDrawer .cart__item--lpg-bundle:not(.cart__item--free)');
  }

  function ghkRerender() {
    document.dispatchEvent(new CustomEvent('cart:build'));
    document.dispatchEvent(new CustomEvent('cart:updated'));
  }

  // Optimistically insert a placeholder cart line so a Frequently Bought Together
  // add FEELS INSTANT — user sees the row the moment they tap, not after
  // /cart/add.js + cart:build land (sequential ~600ms-1s). Two paths:
  //   (a) Live cart → CLONE the bundle paid line (already rendered with the
  //       theme's exact .cart__item structure that the cart CSS expects) and
  //       swap image / title / price. Inserted right after the bundle.
  //   (b) Empty cart → hand-build a faithful .cart__item with the same
  //       structure, appended to [data-products]. This is invisible until the
  //       drawer flips from empty → live, but the moment it does the line is
  //       already there alongside the FBT section — instead of the FBT
  //       showing alone for ~300ms while /cart.ajax populates.
  function ghkOptimisticAdd(btn) {
    try {
      var card = btn.closest('.ghk-paired__item');
      if (!card) return;
      var dp = document.querySelector('#CartDrawer [data-products]');
      if (!dp) return;
      var fbtImg = card.querySelector('img');
      var fbtName = card.querySelector('.ghk-paired__name');
      var fbtPrice = card.querySelector('.ghk-paired__price');
      var name = fbtName ? fbtName.textContent.trim() : '';
      var priceStr = fbtPrice ? fbtPrice.textContent.trim() : '';
      var imgSrc = fbtImg ? fbtImg.src : '';
      var template = dp.querySelector('.cart__item--lpg-bundle:not(.cart__item--free)');
      var ph;
      // Compute per-unit compare from the FBT card's data-ghk-compare (cents).
      // pv.compare_at_price is in cents in Liquid; "0" → no compare.
      var compareCents = parseInt(btn.getAttribute('data-ghk-compare') || '0', 10);
      var priceCents = parseInt(btn.getAttribute('data-ghk-price') || '0', 10);
      var compareStr = '';
      if (compareCents > priceCents && fbtPrice) {
        compareStr = ghkFormatLike(compareCents / 100, priceStr);
      }
      if (template) {
        // (a) Clone-bundle path — structural parity with real cart lines. KEEP
        // .lpg-cart-price (the styled price block we want for FBT too) and only
        // strip the bundle-only bits inside .cart__item-title.
        ph = template.cloneNode(true);
        ph.classList.remove('cart__item--lpg-bundle', 'cart__item--free', 'cart__item--sp-hidden');
        ph.classList.add('ghk-paired-pending');
        ph.setAttribute('aria-busy', 'true');
        // Stash variant in data-key as "VARIANT:pending" so ghkSyncPairedButtons
        // (which extracts variant via data-key.split(':')[0]) can mark the FBT
        // button as "Added" the instant the placeholder lands — before /cart/add.js
        // resolves with the real key.
        var _phVariant = btn.getAttribute('data-ghk-add');
        if (_phVariant) ph.setAttribute('data-key', _phVariant + ':pending');
        ['.cart__item--bundle', '.cart__item--purchase-type', '.lpg-cart-each'].forEach(function (s) {
          var els = ph.querySelectorAll(s);
          for (var i = 0; i < els.length; i++) els[i].remove();
        });
        var cImg = ph.querySelector('.cart__image img');
        if (cImg && fbtImg) { cImg.src = imgSrc; cImg.removeAttribute('srcset'); cImg.alt = name; }
        var cName = ph.querySelector('.cart__item-name');
        if (cName) cName.textContent = name;
        var cQty = ph.querySelector('.js-qty__num');
        if (cQty) cQty.value = '1';
        // Swap the cloned bundle's price (line total) for the FBT per-unit (qty=1).
        var cNow = ph.querySelector('.lpg-cart-now');
        if (cNow) cNow.textContent = priceStr;
        var cCmp = ph.querySelector('.lpg-cart-compare');
        if (compareStr) {
          if (cCmp) cCmp.textContent = compareStr;
        } else if (cCmp) {
          cCmp.remove();
        }
        // Hidden .cart__price kept in sync for theme bookkeeping (it's not the
        // visible price on lp-ghk — .lpg-cart-now is — but the theme may read it).
        var cPrice = ph.querySelector('.cart__price');
        if (cPrice) cPrice.textContent = priceStr;
        if (template.nextSibling) dp.insertBefore(ph, template.nextSibling);
        else dp.appendChild(ph);
      } else {
        // (b) Empty-cart fallback — hand-build matching cart-item.liquid. The
        // .lpg-cart-price block (now + optional compare) carries the visible
        // price on lp-ghk; .cart__item-price-col is kept for theme parity but
        // is hidden by lp-ghk.css.
        ph = document.createElement('div');
        ph.className = 'cart__item ghk-paired-pending';
        ph.setAttribute('aria-busy', 'true');
        var _phVariant2 = btn.getAttribute('data-ghk-add');
        if (_phVariant2) ph.setAttribute('data-key', _phVariant2 + ':pending');
        ph.innerHTML = ''
          + '<div class="cart__image">'
          +   '<a href="#" class="image-wrap" tabindex="-1">'
          +     (imgSrc ? '<img src="' + imgSrc + '" alt="' + name + '" width="60" height="60">' : '')
          +   '</a>'
          + '</div>'
          + '<div class="cart__item-details">'
          +   '<div class="cart__item-title">'
          +     '<a href="#" class="cart__item-name" tabindex="-1">' + name + '</a>'
          +   '</div>'
          +   '<div class="lpg-cart-price" style="display:none;">'
          +     '<span class="lpg-cart-now">' + priceStr + '</span>'
          +     (compareStr ? '<span class="lpg-cart-compare">' + compareStr + '</span>' : '')
          +   '</div>'
          +   '<div class="cart__item-sub">'
          +     '<div>'
          +       '<div class="js-qty__wrapper">'
          +         '<input type="text" class="js-qty__num" name="updates[]" value="1" min="0" pattern="[0-9]*" data-id="">'
          +         '<button type="button" class="js-qty__adjust js-qty__adjust--minus" aria-label="−"><svg viewBox="0 0 20 20" width="14" height="14"><path fill="#444" d="M17.5 11H2.5c-.6 0-1-.5-1-1s.4-1 1-1h15c.6 0 1 .5 1 1s-.4 1-1 1z"/></svg></button>'
          +         '<button type="button" class="js-qty__adjust js-qty__adjust--plus" aria-label="+"><svg viewBox="0 0 20 20" width="14" height="14"><path fill="#444" d="M17.4 8.9h-6.7V2.3c0-.6-.5-1-1.1-1s-1.1.4-1.1 1v6.6H2c-.6 0-1.1.5-1.1 1s.5 1 1 1.1h6.6V17.7c0 .6.5 1 1.1 1s1.1-.4 1.1-1v-6.6h6.7c.6 0 1-.5 1-1.1s-.5-1-1-1z"/></svg></button>'
          +       '</div>'
          +       '<div class="cart__remove">'
          +         '<a href="#" class="cart__remove-icon" tabindex="-1"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><line x1="10" y1="11" x2="10" y2="17"/><line x1="14" y1="11" x2="14" y2="17"/></svg></a>'
          +       '</div>'
          +     '</div>'
          +     '<div class="cart__item-price-col text-right"><span class="cart__price">' + priceStr + '</span></div>'
          +   '</div>'
          + '</div>';
        dp.appendChild(ph);
      }
    } catch (e) { lpgLog('optAdd', e); }
  }

  // Promote the placeholder into a canonical cart line. Critically, REBIND every
  // key-keyed attribute (input id, data-id, label for, remove href) to the
  // server-issued line key — otherwise the theme's qty stepper reads the BUNDLE's
  // leftover key (we cloned from the bundle) and ends up mutating the bundle line
  // when the user clicks +/- on the FBT row.
  function ghkPromotePlaceholder(newKey) {
    try {
      var ph = document.querySelector('#CartDrawer .ghk-paired-pending');
      if (!ph) return;
      if (newKey) {
        ph.setAttribute('data-key', newKey);
        var qInput = ph.querySelector('.js-qty__num');
        if (qInput) {
          qInput.setAttribute('id', 'cart_updates_' + newKey);
          qInput.setAttribute('data-id', newKey);
        }
        var label = ph.querySelector('label[for]');
        if (label) label.setAttribute('for', 'cart_updates_' + newKey);
        var removeA = ph.querySelector('.cart__remove a');
        if (removeA) {
          var route = (window.theme && window.theme.routes && window.theme.routes.cart_change_url) || '/cart/change';
          removeA.setAttribute('href', route + '?id=' + newKey + '&quantity=0');
        }
      }
      // Wire up the theme's qty stepper on the placeholder. The theme uses
      // theme.QtySelector — bound per element, NOT delegated — and only ever
      // instantiates on cart:build via CartForm.reInit(). Since we skip
      // cart:build to avoid the flicker, the placeholder's +/- buttons have no
      // listeners until we attach one ourselves. Namespace ".cart-cart-drawer"
      // matches CartForm's `'.cart-' + form.dataset.location` (form is
      // data-location="cart-drawer"), so cart:quantity events route to the
      // drawer's CartForm just like a server-rendered line would.
      if (window.theme && theme.QtySelector) {
        var wrapper = ph.querySelector('.js-qty__wrapper');
        if (wrapper) {
          try { new theme.QtySelector(wrapper, { namespace: '.cart-cart-drawer', isCart: true }); }
          catch (e) { lpgLog('qtybind', e); }
        }
      }
      ph.classList.remove('ghk-paired-pending');
      ph.removeAttribute('aria-busy');
    } catch (e) { lpgLog('promote', e); }
  }

  // Move the GHK bundle paid line to the FIRST position in [data-products] so
  // FBT-added items always render BELOW it, never above.
  function ghkOrderItems() {
    try {
      var dp = document.querySelector('#CartDrawer [data-products]');
      if (!dp) return;
      var bundle = dp.querySelector('.cart__item--lpg-bundle:not(.cart__item--free)');
      if (bundle && bundle !== dp.firstElementChild) {
        dp.insertBefore(bundle, dp.firstElementChild);
      }
    } catch (e) { lpgLog('orderItems', e); }
  }

  // Sync each Frequently Bought Together button's text to whether its variant is
  // currently in the cart. "Add + $X.XX" when not in cart; "Added" when it is.
  // Matches by variant_id (data-ghk-add on the button vs the variant prefix of
  // each cart line's data-key — Shopify line keys are "<variant_id>:<hash>").
  // Stashes the original innerHTML once so the revert restores it exactly.
  function ghkSyncPairedButtons() {
    try {
      var inCart = {};
      var lines = document.querySelectorAll('#CartDrawer [data-products] .cart__item:not(.cart__item--free):not(.cart__item--sp-hidden):not(.cart__item--lpg-bundle)');
      for (var i = 0; i < lines.length; i++) {
        var k = lines[i].getAttribute('data-key') || '';
        var v = k.split(':')[0];
        if (v) inCart[v] = true;
      }
      var btns = document.querySelectorAll('[data-ghk-add]');
      for (var j = 0; j < btns.length; j++) {
        var btn = btns[j];
        var variant = btn.getAttribute('data-ghk-add');
        if (!btn.dataset.originalHtml) btn.dataset.originalHtml = btn.innerHTML;
        var added = !!inCart[variant];
        if (added && !btn.classList.contains('ghk-paired__add--added')) {
          btn.classList.add('ghk-paired__add--added');
          btn.innerHTML = 'Added';
        } else if (!added && btn.classList.contains('ghk-paired__add--added')) {
          btn.classList.remove('ghk-paired__add--added');
          btn.innerHTML = btn.dataset.originalHtml;
        }
      }
    } catch (e) { lpgLog('syncPaired', e); }
  }

  // Cart sync is DEBOUNCED: rapid toggles collapse into ONE reconcile, so the
  // display never lags behind a storm of add/remove requests + re-renders.
  function ghkSyncProtectionDebounced() {
    clearTimeout(spSyncTimer);
    spSyncTimer = setTimeout(ghkSyncProtectionNow, 320);
  }
  // Reconcile the real cart to whatever the toggle shows. Protection is an ADD-ON,
  // never a product: it belongs in the cart only when (a) the toggle is on AND
  // (b) there's a real product present. So a protection-only cart is treated as
  // empty — SP is actively REMOVED, not just left out. No-op when already correct.
  function ghkSyncProtectionNow() {
    var tog = document.querySelector('[data-ghk-protect-toggle]');
    if (!tog) return;
    if (spBusy) { ghkSyncProtectionDebounced(); return; } // retry once the in-flight one lands
    var variant = tog.getAttribute('data-ghk-protect-variant');
    if (!variant) return;
    spBusy = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var items = c.items || [];
        var line = items.filter(function (it) { return String(it.variant_id) === String(variant); })[0];
        var has = !!line;
        // A real product = a line that isn't the protection variant and isn't a $0
        // Kaching "free" line. Protection alone never makes a cart non-empty.
        var hasProduct = items.some(function (it) {
          return String(it.variant_id) !== String(variant) && it.final_price !== 0 && it.price !== 0;
        });
        var want = tog.checked && hasProduct;
        // Position check: SP must be the LAST line in the cart so it renders at
        // the bottom of the checkout order summary (clean "shipping protection"
        // line under everything else). Shopify orders cart.items by add-time —
        // no reorder API — so if SP exists but isn't last (e.g. user added an
        // FBT item after toggling SP on), we remove + re-add it.
        var spIsLast = has && items.length > 0 && String(items[items.length - 1].variant_id) === String(variant);
        var needsReorder = want && has && !spIsLast;
        if (has === want && !needsReorder) { spBusy = false; return; } // cart already matches
        var addReq = function () {
          return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ items: [{ id: parseInt(variant, 10), quantity: 1 }] }) });
        };
        var removeReq = function () {
          return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ id: line.key, quantity: 0 }) });
        };
        var req = needsReorder
          ? removeReq().then(addReq)
          : (want ? addReq() : removeReq());
        return req.then(function () {
          spBusy = false;
          // Footer total only — do NOT buildCart here. SP is a HIDDEN line
          // (cart__item--sp-hidden) and the total already counts it via the toggle,
          // so a full re-render is pointless — and it was re-rendering the BUNDLE
          // line mid-interaction, which reset the display-only tier stepper (the
          // "image flicker" that left +/- dead for a couple seconds after add).
          // 19h ago there was no SP auto-add, so the step stuck. The hidden SP line
          // reconciles on the next natural buildCart (trash, paired-add, reopen).
          ghkFootRender();
        });
      })
      .catch(function () { spBusy = false; });
  }

  // Toggle → INSTANT total. The toggle (via the opt-out flag) is the display
  // truth; repaint the footer synchronously (~0ms). The cart sync is DEBOUNCED so
  // rapid on/off can't lag behind an add/remove + re-render storm.
  document.addEventListener('change', function (e) {
    var tog = e.target.closest('[data-ghk-protect-toggle]');
    if (!tog) return;
    if (tog.checked) sessionStorage.removeItem(SP_OPTOUT_KEY);
    else sessionStorage.setItem(SP_OPTOUT_KEY, '1');
    ghkFootRender();                  // instant total (reads the toggle)
    ghkSyncProtectionDebounced();     // cart catches up once, after clicks settle
  });

  // "Frequently paired with" — + button adds the variant, then re-renders
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ghk-add]');
    if (!btn) return;
    e.preventDefault();
    // CRITICAL: stop the click from bubbling to the theme's window-level
    // outside-click listener. We rewrite btn.innerHTML to "Added" later in this
    // handler (ghkSyncPairedButtons), which detaches the original click target.
    // The theme's close handler then sees a target with no parent — its
    // evt.target.closest('.drawer') returns null and it treats it as an
    // outside-the-drawer click → closes the drawer. stopPropagation prevents
    // that listener from firing at all.
    e.stopPropagation();
    // Already in cart → button shows "Added", clicking is a no-op (use +/- on
    // the cart line to add more). Prevents accidental duplicate adds.
    if (btn.classList.contains('ghk-paired__add--added')) return;
    var variant = btn.getAttribute('data-ghk-add');
    if (!variant) return;
    // Snapshot empty-state BEFORE inserting the placeholder — the placeholder
    // itself doesn't make the drawer non-empty in the theme's eyes, but we need
    // to know if a state switch (cart:build) is required after the add.
    var inner = document.querySelector('#CartDrawer .drawer__inner');
    var wasEmpty = !!(inner && getComputedStyle(inner).display === 'none');
    // Disable just long enough to insert the placeholder, then immediately
    // re-enable — the user already sees the row in the cart, so keeping the
    // button greyed out for the full /cart/add.js roundtrip felt out of sync.
    btn.setAttribute('disabled', 'disabled');
    ghkOptimisticAdd(btn);   // INSTANT placeholder row, in both live AND empty states
    ghkSyncPairedButtons();  // flip the button text to "Added" right away
    btn.removeAttribute('disabled');
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ items: [{ id: parseInt(variant, 10), quantity: 1 }] }) })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var newKey = data && data.items && data.items[0] && data.items[0].key;
        // Promotion rebinds every key-keyed attribute (id, data-id, label for,
        // remove href) so the theme's qty stepper routes +/- to THIS line —
        // not the bundle's key it inherited from the clone template.
        ghkPromotePlaceholder(newKey);
        if (wasEmpty) {
          // Cart was empty → drawer has to switch from .drawer__cart-empty to
          // .drawer__inner. cart:build does the state switch (the theme owns
          // .is-empty). The placeholder is already inside [data-products], so
          // the moment the drawer flips to live, the new line appears at the
          // SAME TIME as the FBT section — not after it. The wholesale
          // re-render that follows briefly flickers as the server-rendered
          // line replaces the placeholder; acceptable for the first-add case.
          ghkRerender();
        } else {
          // Live cart → footer total + count + free-ship bar only, no DOM
          // rebuild. Backend-only promote, zero visual flicker.
          document.dispatchEvent(new CustomEvent('cart:updated'));
        }
      })
      .catch(function () { btn.removeAttribute('disabled'); });
  });

  // Recompute the footer on every drawer render path. Protection sync runs ONLY on
  // drawer-open + the toggle (below) — NOT on every cart:build. Re-syncing on each
  // rebuild made it thrash while Kaching settles the bundle's free lines (add SP →
  // rebuild → "has product?" flips → sync again → rebuild …), which churned the
  // drawer for ~15s and kept wiping the tier stepper. One sync on open is enough.
  // Kill in-cart navigation on lp-ghk: AJAX cart re-render uses generic cart-item
  // markup (template.suffix isn't 'lp-ghk' inside the cart view), so the liquid
  // guard misses. JS guard catches every <a> inside the drawer that points at a
  // product/collection so the customer can't exit the funnel.
  if (IS_GHK) {
    document.addEventListener('click', function (e) {
      var drawer = e.target.closest('#CartDrawer');
      if (!drawer) return;
      var a = e.target.closest('a.image-wrap, a.cart__item-name, a.ghk-paired__img');
      if (!a) return;
      e.preventDefault();
      e.stopPropagation();
    }, true);
  }
  document.addEventListener('cart:updated', function () { setTimeout(function () { ghkFootRender(); ghkSyncPairedButtons(); }, 30); ghkSyncProtectionDebounced(); });
  // Auto-close the cart drawer the moment the cart becomes empty (last line removed).
  // Polls /cart.js once after each cart:updated/build because the events fire BEFORE
  // the theme has refreshed cart.item_count in the DOM, so we ask the source of truth.
  function ghkCloseDrawerIfEmpty() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        if (!c || c.item_count > 0) return;
        // Excluding any auto-added shipping-protection line: a cart that ONLY contains
        // the SP add-on is also "empty" from the user's perspective.
        document.dispatchEvent(new CustomEvent('cart:close'));
        var drawer = document.querySelector('#CartDrawer');
        if (drawer) drawer.classList.remove('js-drawer-open', 'is-open');
      })
      .catch(function () {});
  }
  document.addEventListener('cart:updated', function () { setTimeout(ghkCloseDrawerIfEmpty, 120); });
  document.addEventListener('cart:build',   function () { setTimeout(ghkCloseDrawerIfEmpty, 120); });
  document.addEventListener('cart:build', function () { ghkOrderItems(); ghkSyncPairedButtons(); setTimeout(function () { ghkOrderItems(); ghkFootRender(); ghkSyncPairedButtons(); }, 120); });
  document.addEventListener('drawerOpen.CartDrawer', function () { setTimeout(function () { ghkFootRender(); ghkSyncPairedButtons(); }, 80); ghkSyncProtectionDebounced(); });
  // Catch the instant-stepper repaint (DOM mutates without a cart event)
  (function () {
    var cd = document.querySelector('#CartDrawer');
    if (!cd || !window.MutationObserver) return;
    var t; new MutationObserver(function () { ghkOrderItems(); ghkSyncPairedButtons(); clearTimeout(t); t = setTimeout(ghkFootRender, 60); }).observe(cd, { childList: true, subtree: true, characterData: true });
  })();
  setTimeout(ghkFootRender, 400);
  } // end IS_GHK gate

  waitForKaching();
})();
